import {styled} from 'styled-components';

export const NotificationWrapper = styled.div`
  max-width: 49.5rem;
`;
